import { useMatchMedia } from '../../../hooks/useMatchMedia'

export const useLaptopHelperItemSpec = (): 'right' | 'bottom' => {
  const isDesktop = useMatchMedia('(min-width: 768px)')

  return isDesktop ? 'right' : 'bottom'
}
